import { Provider } from 'effector-react';
import { createFilterToolbarScope } from './model/main';
import { Props, FilterToolbarBody } from './organisms/page';

export const FilterToolbar = (props: Props) => {
  const scope = createFilterToolbarScope(props.config.id);

  return (
    <Provider value={scope}>
      <FilterToolbarBody {...props} />
    </Provider>
  );
};
